export var strings = {
  'APP.FORM.LABEL.ZIPCODE': 'Zip/Postal Code',
  'APP.FORM.ZIPCODE.OPTIONAL': ' (optional)',
  'APP.FORM.LABEL.CITY': 'CHOOSE YOUR CITY',
  'APP.FORM.LABEL.COUNTRY': 'COUNTRY',
  'APP.FORM.ZIP.PLACEHOLDER': '11111',
  'APP.FORM.COUNTRY.PLACEHOLDER': 'Search Country',
  'APP.COUNTRYLIST.NAME': '{name}',
  'APP.COUNTRYLIST.ERROR.INVALID': 'Country is invalid',
  'APP.ZIPCODE.ERROR.INVALID': 'Zip/Postal Code is invalid',
  'APP.CITY.ERROR': 'You must select a city',
  'APP.FROM.COUNTRY.LABEL': 'Country',
  'APP.RIO.EVENTS.EL_VALUE.USER_SELECTS_COUNTRY': 'Country {country} Selected In User Address Component',
  'APP.UPI.PINCODE.ERROR.LENGTH': 'Pincode should be 6 digits'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/constants/strings.js
// module id = 493
// module chunks = 11